var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "styled-components";
const SVGContainer = styled.svg `
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
	transition: all ease 0.2s;
`;
export default class MyIcon extends React.PureComponent {
    render() {
        const _a = this.props, { type, className, style, width, height, size, color } = _a, props = __rest(_a, ["type", "className", "style", "width", "height", "size", "color"]);
        const w = size || width;
        const h = size || height;
        return (React.createElement(SVGContainer, Object.assign({ className: className, style: Object.assign({ width: w, height: h, color }, style), "aria-hidden": "true" }, props),
            React.createElement("use", { xlinkHref: `#icon-${type}` })));
    }
}
